module.exports = __webpack_public_path__ + "img/md.92b4e050.svg";